import { Injectable, Injector } from '@angular/core';
import {firstValueFrom} from 'rxjs';
import { first } from 'rxjs/operators';

import { SettingsClassName } from '@atmi/core/models';
import { CollectionClassName } from '@sim/collections/models/collection';
import { CollectionApiService, CollectionItemApiService } from '@sim/collections/services';

import { required } from '../utils';
import { CardsApiService, CardType } from './cards-api.service';
import { SourceArcApiService } from './source-arc-api.service';
import { SourceBibApiService } from './source-bib-api.service';

@Injectable({
  providedIn: 'root',
})
export class ExportsApiSDispatcherervice {

  constructor(
    private readonly cardApi: CardsApiService,
    private readonly injector: Injector,
    private readonly sourceArcApi: SourceArcApiService,
    private readonly sourceBibApi: SourceBibApiService,
  ) {
  }

  dispatchExport(
    className: CollectionClassName | SettingsClassName,
    entityId: string,
    format?: string,
    template?: string,
    cardType?: CardType,
  ) {
    switch (className) {
      case 'Base':
      case 'BeneD':
      case 'BeneF':
      case 'BeneMI':
      case 'BeneOA':
      case 'BeneS':
        required(cardType);
        return firstValueFrom(this.cardApi.exportCard(entityId, cardType, format, template).pipe(first()));
      case 'DocumentoArc':
        return firstValueFrom(this.sourceArcApi.exportArc(entityId, template, format).pipe(first()));
      case 'DocumentoBib':
        return firstValueFrom(this.sourceBibApi.exportBib(entityId, template, format).pipe(first()));
      case 'Collezione':
        const collectionApi = this.injector.get(CollectionApiService);
        return firstValueFrom(collectionApi.exportCollection(entityId, template, format).pipe(first()));
      case 'OggettoCollezione':
        const collectionItemApi = this.injector.get(CollectionItemApiService);
        return firstValueFrom(collectionItemApi.exportList(entityId, template, format, {}).pipe(first()));
      default:
        throw new Error('Cannot dispatch export API without a defined class name');
    }
  }

  getExportName(
    className: CollectionClassName | SettingsClassName,
    name: string,
    cardType?: CardType,
  ) {
    switch (className) {
      case 'Base':
      case 'BeneD':
      case 'BeneF':
      case 'BeneMI':
      case 'BeneOA':
      case 'BeneS':
        required(cardType);
        return `bene-${cardType}-${name}`;
      case 'DocumentoArc':
        return `documento-archivistico-${name}`;
      case 'DocumentoBib':
        return `documento-bibliografico-${name}`;
      case 'Collezione':
        return `collezione-${name}`;
      case 'OggettoCollezione':
        return `oggetti-collezione-${name}`;
      default:
        throw new Error('Cannot get export name without a defined class name');
    }
  }
}
